import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import MainPage from '../components/MainPage';
import { openTrash, updateTrashInfo, initTrashInfo } from '../actions/trash';

const INTERVAL_TIMER = 5000;

const scrollTop = () => {
  // ページネーションなどでページ更新した時にスクロールバーをトップに戻す
  const obj = document.getElementById('canScrollTable');
  if (obj) {
    obj.scrollTop = 0;
  }
};

const getSearchBoxHeight = () => {
  const headerNotice = document.getElementById('headerNotice');
  const title = document.getElementById('title');
  const searchBox = document.getElementById('TimeLinePageSearchBox');
  const toolBar = document.getElementById('TimeLineToolBar');
  const pagenation = document.getElementById('timeLinePagenation');
  const height =
    (headerNotice && headerNotice.clientHeight) +
    (title && title.clientHeight) +
    (searchBox && searchBox.clientHeight) +
    (toolBar && toolBar.clientHeight) +
    (pagenation && pagenation.clientHeight) +
    15;
  return height || 0;
};

class TrashContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBoxHeight: 0,
    };
    const openCalendar = !!(
      props &&
      props.calendarData &&
      props.calendarData.name
    );
    const params = {
      canUpdate: !props.showUserPrompt || props.isLogin || !openCalendar,
      searchOptions: (props && props.searchOptions) || {},
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      showUserPrompt: props && props.showUserPrompt,
      openCalendar,
    };
    openTrash(params.dispatch);
    if (params.canUpdate) {
      this.initialTimer(params);
    }
  }

  componentDidMount() {
    const searchBoxHeight = getSearchBoxHeight();
    this.setState({ searchBoxHeight });
  }

  shouldComponentUpdate(props, state) {
    scrollTop();
    const resizedSearchBoxHeight = getSearchBoxHeight();
    const curSearchBoxHeight = state.searchBoxHeight;
    if (resizedSearchBoxHeight !== curSearchBoxHeight) {
      this.setState({ searchBoxHeight: resizedSearchBoxHeight });
    }
    const openCalendar = !!(
      props &&
      props.calendarData &&
      props.calendarData.name
    );
    const params = {
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      showUserPrompt: props && props.showUserPrompt,
      openCalendar,
      searchOptions: props && props.searchOptions,
      searchOptionsError: props && props.searchOptionsError,
      selectedTagIds: props && props.selectedTagIds,
      targetGroupId: props && props.targetGroupId,
    };
    const { searchOptionsError } = params;
    if (
      !searchOptionsError.recordedDateFrom &&
      !searchOptionsError.recordedDateTo
    ) {
      this.initialTimer(params);
    }
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
    const { dispatch } = this.props;
    initTrashInfo(dispatch);
  }

  initialTimer(params) {
    const {
      searchOptions,
      selectedTagIds,
      targetGroupId,
      apiToken,
      dispatch,
      showUserPrompt,
      openCalendar,
    } = params;
    this.closeTimer();
    if (dispatch && apiToken && !showUserPrompt && !openCalendar) {
      updateTrashInfo(
        dispatch,
        apiToken,
        searchOptions,
        selectedTagIds,
        targetGroupId,
      );
      this.mainTimer = setInterval(
        () =>
          updateTrashInfo(
            dispatch,
            apiToken,
            searchOptions,
            selectedTagIds,
            targetGroupId,
          ),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    const { searchBoxHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <MainPage searchBoxHeight={searchBoxHeight} />
      )
    );
  }
}

TrashContainer.propTypes = {
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  calendarData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchOptions: PropTypes.object.isRequired,
  searchOptionsError: PropTypes.object.isRequired,
  selectedTagIds: PropTypes.array.isRequired,
  targetGroupId: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  apiToken: state.main.apiToken,
  showUserPrompt: state.userPrompt.showUserPrompt,
  calendarData: state.main.calendarData,
  searchOptions: state.trash.trashInfo.searchOptions,
  searchOptionsError: state.trash.trashInfo.searchOptionsError,
  selectedTagIds: state.trash.trashInfo.selectedTagIds,
  targetGroupId: state.main.targetGroupId,
});

export default connect(mapStateToProps)(TrashContainer);
